import { api, getEffectiveSession } from "./api";

const SESSION_ID_KEY = "plg_session_id";

let fallbackSessionId: string | null = null;

const getSessionId = (): string => {
    try {
        let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
        if (!sessionId) {
            sessionId = crypto.randomUUID();
            sessionStorage.setItem(SESSION_ID_KEY, sessionId);
        }
        return sessionId;
    } catch {
        // sessionStorage unavailable (private browsing, quota exceeded) —
        // cache in module-level variable so all calls in this page lifecycle share the same ID
        if (!fallbackSessionId) {
            fallbackSessionId = crypto.randomUUID();
        }
        return fallbackSessionId;
    }
};

export const trackPLGEvent = async (eventName: string, properties?: Record<string, unknown>): Promise<void> => {
    try {
        const payload = {
            event_name: eventName,
            properties: properties ?? {},
            source: "web",
            session_id: getSessionId(),
        };

        // Use api (ky) directly instead of apiFetch to avoid Sentry noise —
        // PLG tracking is fire-and-forget and should never pollute error monitoring.
        const session = await getEffectiveSession();

        if (session) {
            const { accessToken, userId, isImpersonating } = session;
            await api.post("plg/events", {
                json: payload,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    ...(isImpersonating ? { "X-Effective-User-Id": userId } : {}),
                },
            });
        } else {
            await api.post("plg/events", { json: payload });
        }
    } catch (err) {
        console.warn("[PLG] Tracking failed", eventName, err);
    }
};
